<div class="updated-container d-flex flex-column">
  <div class="d-flex justify-content-between align-items-center">
    <span class="updated-text">Are you updated?</span>
    <div class="img-container" mat-dialog-close>
      <img
        src="../../../assets/images/crossIconDarkTheme.svg"
        alt="close icon"
        class="cross-icon"
      />
    </div>
  </div>
  <div class="table-container">
    <dp-table
      [dataTable]="data"
      [displayedColumns]="displayColumnData"
      [componentMap]="cellComponentMap"
    ></dp-table>
  </div>
</div>
